/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeGCSInspections.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   GCS Inspection Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Wednesday, April 03, 2019 - 04:09:39 AM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      04/03/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const GCSINSPECTION_LIST_CONTAINER_LOADED = 'GCSINSPECTION_LIST_CONTAINER_LOADED';
export const GCSINSPECTION_LIST_CONTAINER_UNLOADED = 'GCSINSPECTION_LIST_CONTAINER_UNLOADED';
export const GCSINSPECTION_LIST_TABLE_LOADED = 'GCSINSPECTION_LIST_TABLE_LOADED';
export const GCSINSPECTION_LIST_TABLE_UNLOADED = 'GCSINSPECTION_LIST_TABLE_UNLOADED';

export const GCSINSPECTION_LIST_CHANGE_GROUP = 'GCSINSPECTION_LIST_CHANGE_GROUP';
export const GCSINSPECTION_SELECT_ROW = 'GCSINSPECTION_SELECT_ROW';

export const GCSINSPECTION_ADD = 'GCSINSPECTION_ADD';
export const GCSINSPECTION_EDIT = 'GCSINSPECTION_EDIT';
export const GCSINSPECTION_DELETE = 'GCSINSPECTION_DELETE';
export const GCSINSPECTION_OPEN_WARNING = 'GCSINSPECTION_OPEN_WARNING';
export const GCSINSPECTION_CLOSE_WARNING = 'GCSINSPECTION_CLOSE_WARNING';
export const GCSINSPECTION_DELETE_DISABLE = 'GCSINSPECTION_DELETE_DISABLE';
export const GCSINSPECTION_VIEW_CHILD_ITEMS = 'GCSINSPECTION_VIEW_CHILD_ITEMS';

export const GCSINSPECTION_EDIT_CONTAINER_LOADED = 'GCSINSPECTION_EDIT_CONTAINER_LOADED';
export const GCSINSPECTION_EDIT_CONTAINER_UNLOADED = 'GCSINSPECTION_EDIT_CONTAINER_UNLOADED';
export const GCSINSPECTION_EDIT_FORM_LOADED = 'GCSINSPECTION_EDIT_FORM_LOADED';
export const GCSINSPECTION_EDIT_FORM_UNLOADED = 'GCSINSPECTION_EDIT_FORM_UNLOADED';

export const GCSINSPECTION_SET_GROUP_SELECT = 'GCSINSPECTION_SET_GROUP_SELECT';
export const GCSINSPECTION_EDIT_DATA_LOAD = 'GCSINSPECTION_EDIT_DATA_LOAD';

export const GCSINSPECTION_EDIT_CONTAINER_SUBMIT = 'GCSINSPECTION_EDIT_CONTAINER_SUBMIT';
export const GCSINSPECTION_EDIT_CONTAINER_CANCEL = 'GCSINSPECTION_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeGCSInspections.js